import React from 'react';
import ReactDOM from 'react-dom/client';
// Global styles (in exact order)
import './styles/globals.css';
import './styles/typography.css';
import './styles/animations.css';
import './styles/utilities.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Web Vitals: log key metrics in development for performance analysis.
// In production you can swap this to POST to a monitoring endpoint.
reportWebVitals((metric) => {
  if (process.env.NODE_ENV === 'development') {
    // Example: CLS, LCP, FID/INP, TTFB, FCP
    // Rounded for readability in the console.
    // Full metric object is still available if needed.
    // eslint-disable-next-line no-console
    console.log(
      '[Web Vitals]',
      metric.name,
      Math.round(metric.value),
      {
        id: metric.id,
        label: metric.label,
        rating: metric.rating,
      }
    );
  }
});
